import { titleCase } from "change-case-all";
import * as Yup from "yup";

export const customFieldsDetailsObject = {
  ID: "",
  controlID: 3,
  platforms: [],
  description: "",
  copyable: true,
  editable: true,
  isActive: true,
  label: "",
  mandatory: false,
  maxLength: "",
  multiline: false,
  name: "",
  rows: 0,
  regex: "",
  errorMessage: "",
  tooltip: "",
  createdAt: "",
  updatedAt: "",
  createdBy: "",
  updatedBy: "",
};

export function controlText(formikProps, controlID) {
  formikProps.setValues(() => ({
    controlID: controlID,
    copyable: false,
    isActive: true,
    label: "",
    length: "",
    maxLength: 256,
    multiline: false,
    name: "",
    editable: true,
    mandatory: true,
    regex: "",
    errorMessage: "",
  }));
}

export function dateTime(formikProps, controlID) {
  formikProps.setValues(() => ({
    controlID: controlID,
    editable: true,
    mandatory: true,
    isActive: true,
    label: "",
    name: "",
    end_date: null,
    start_date: null,
    disabled_days: [],
    daysDisabled: [],
  }));
}

export function range(formikProps, controlID) {
  formikProps.setValues(() => ({
    controlID: controlID,
    copyable: false,
    isActive: true,
    label: "",
    length: "",
    maxLength: 256,
    multiline: false,
    name: "",
    editable: true,
    mandatory: true,
    regex: "",
    regex1: "",
    regex2: "",
    rangelabel2: "",
    rangelabel1: "",
    errorMessage: "",
  }));
}

export function dropDown(formikProps, controlID) {
  formikProps.setValues(() => ({
    controlID: controlID,
    editable: true,
    mandatory: true,
    isActive: true,
    label: "",
    multi_Select: false,
    options: [],
    name: "",
    sort_type: "",
  }));
}

export function switchControl(formikProps, response) {
  formikProps.setValues(() => ({
    controlID: response.data._id,
    editable: true,
    mandatory: true,
    name: response.data.name,
    isActive: response.data.is_active,
    defaultSelection: false,
  }));
}

export function fileControl(formikProps, controlID) {
  formikProps.setValues(() => ({
    controlID: controlID,
    editable: true,
    mandatory: true,
    isActive: true,
    label: "",
    name: "",
    description: "",
    tooltip: "",
    allowedExtensions: "",
    allowedSize: "",
    errorMessage: "",
  }));
}

export function objectFromResponse(response) {
  var data = {
    groupID: parseInt(response.category_id),
    ID: response.field_id,
    controlID: response.field_type_id,
    editable: response.editable,
    description: response.description || "",
    isActive: response.is_active,
    label: response.field_label,
    mandatory: response.is_mandatory || false,
    name: response.field_name,
    tooltip: response.tooltip,
    platforms: response.platform_ids,
  };

  if (response.field_type_id === 3) {
    data = {
      ...data,
      regex: response.regex,
      multiline: response.multiline,
      copyable: response.copyable,
      rows: response.rows,
      errorMessage: response.error_message,
    };
  }
  if (response.field_type_id === 4) {
    data = {
      ...data,
      end_date: response.end_date,
      start_date: response.start_date,
      disabled_days: response.disabled_days,
      daysDisabled: response.disabled_days?.map((days) => days.id),
    };
  }
  if (response.field_type_id === 2) {
    data = {
      ...data,
      multi_Select: response.multi_select,
      options: response.fieldOptions,
      sortingOrder: response.sort_type,
    };
  }
  if (response.field_type_id === 1) {
    data = {
      ...data,
      maxDefaultValue:
        response.max_default_val ?? parseInt(response.max_default_val),
      minDefaultValue:
        response.min_default_val ?? parseInt(response.min_default_val),
      rangelabel1: response.fieldOptions[0]?.option_text,
      rangelabel2: response.fieldOptions[1]?.option_text,
    };
  }

  return data;
}

export function objectFromFormData(formData) {
  var data = {
    ...(Boolean(formData.ID) && {
      field_id: formData.ID,
    }),

    is_deleted: false,
    field_type_id: formData.controlID,
    field_label: titleCase(formData.label),
    is_mandatory: formData.mandatory,
    field_name: formData.label.replace(/\s+/g, "_").toLowerCase(),
    tooltip: formData.tooltip || "",
    editable: formData.editable,
    is_active: formData.isActive,
    description: formData.description,
    category_id: parseInt(formData.groupID),
    platform_ids: formData.platforms,
  };

  if (formData.controlID === 3) {
    data = {
      ...data,
      regex: formData.regex,
      multiline: formData.multiline,
      copyable: formData.copyable,
      rows: formData.rows,
      error_message: formData.errorMessage,
    };
  }

  if (formData.controlID === 1) {
    data = {
      ...data,
      min_default_val: parseInt(formData.minDefaultValue),
      max_default_val: parseInt(formData.maxDefaultValue),
      options: [
        { option_value: "min", option_text: formData.rangelabel1, sequence: 1 },
        { option_value: "max", option_text: formData.rangelabel2, sequence: 2 },
      ],
    };
  }

  if (formData.controlID === 4) {
    data = {
      ...data,
      end_date: formData.end_date,
      start_date: formData.start_date,
      disabled_days: formData.disabled_days,
    };
  }

  if (formData.controlID === 2) {
    data = {
      ...data,
      multi_Select: formData.multi_Select,
      options: formData.options,
    };
  }

  return data;
}

export const validationSchema = Yup.object().shape({
  controlID: Yup.string().required("Please select component type."),
  platforms: Yup.array().required("Please select platform."),
  groupID: Yup.string().required("Please select group."),
  isActive: Yup.string().required("Please select field status."),
  label: Yup.string().required("Provide the label."),
  description: Yup.string().required("Fill  the description."),
  name: Yup.string().required("Provide  the name."),
  minDefaultValue: Yup.string().when("controlID", {
    is: (ID) => ID === 1,
    then: () =>
      Yup.string()
        .matches(/^[0-9]+$/, "Provide Integer value")
        .required("Provide  the min default value."),
  }),

  maxDefaultValue: Yup.string().when("controlID", {
    is: (ID) => ID === 1,
    then: () =>
      Yup.string()
        .matches(/^[0-9]+$/, "Provide Integer value")
        .required("Provide  the max default value."),
  }),

  regex: Yup.string().when("controlID", {
    is: (ID) => ID === 3,
    then: Yup.string().required("Give a regex to validate you field."),
  }),

  errorMessage: Yup.string().when("controlID", {
    is: (ID) => ID === 3,
    then: () =>
      Yup.string().required(
        "Give error message to display if the field doesn't satisfy regex."
      ),
  }),

  rangelabel1: Yup.string().when("controlID", {
    is: (ID) => ID === 1,
    then: () => Yup.string().required("Give label to field min option."),
  }),

  rangelabel2: Yup.string().when("controlID", {
    is: (ID) => ID === 1,
    then: () => Yup.string().required("Give label to field max option."),
  }),
});
